import { Component } from '@angular/core';
import { WizardPageComponent } from '../../../../core/wizard/wizard-page-component';
import type { LicenseExpiredWizard } from '../license-expired-wizard';
import { DatePipe } from '@angular/common';
import { InsightsDatePipe } from '../../../../core/date/insights-date.pipe';

@Component({
  standalone: false,
  selector: 'mtn-license-expired-page',
  templateUrl: './license-expired-page.component.html',
  styleUrls: ['./license-expired-page.component.scss'],
  providers: [DatePipe, InsightsDatePipe]
})
export class LicenseExpiredPageComponent extends WizardPageComponent<LicenseExpiredWizard> {

  key = 'license-expired';

  constructor() {
    super();
    this.title = 'License Expired';
    this.closeButtonText = 'Close';
  }

}
